export interface Category {
  name: string;
  url: string;
  icon: string;
  hot?: boolean;
}

export const categories: Category[] = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line', hot: true },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line', hot: true },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-t-shirt-2-line' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-user-smile-line' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-checkbox-blank-line' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-trophy-line' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-shopping-bag-line' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-briefcase-line' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-flask-line' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];

export const stats = [
  { value: '10,000+', label: 'Curated Items' },
  { value: '500+', label: 'Best Finds' },
  { value: '100%', label: 'Safe Buying Links' },
  { value: '15+', label: 'Categories Covered' },
];

export const faqs = [
  {
    question: 'What is Vigorbuy Spreadsheet?',
    answer: 'The Vigorbuy Spreadsheet is a carefully curated resource that helps buyers organize products, compare categories, discover popular items, and make smarter purchasing decisions. It includes product lists, pricing comparisons, QC checklists, and direct links to verified sources. Updated daily to ensure accuracy and relevance for every category from sneakers to accessories.',
  },
  {
    question: 'Is Vigorbuy safe to use?',
    answer: 'Absolutely. All links in the Vigorbuy Spreadsheet are verified and sourced from trusted platforms. We provide safety tips, QC guides, and transparent product information so you can shop with complete confidence. Our commitment to safe buying practices is a core pillar of the Vigorbuy experience.',
  },
  {
    question: 'How do I use the Vigorbuy Spreadsheet?',
    answer: 'Simply browse through the categories, click on any product link that interests you, and you will be directed to the official store page. The spreadsheet is organized by category for easy navigation. Each entry includes key details like sizing, pricing range, and direct purchase links. Beginners can start with our getting-started guide.',
  },
  {
    question: 'How often are the guides updated?',
    answer: 'Our spreadsheets and guides are updated on a daily basis. New products, categories, and resources are added regularly to reflect the latest trends and availability. We maintain a rigorous update schedule to ensure every link, price reference, and guide recommendation remains current and reliable.',
  },
  {
    question: 'Is the Vigorbuy Spreadsheet free?',
    answer: 'Yes, the Vigorbuy Spreadsheet and all associated guides, QC checklists, buying tips, and category resources are completely free. We believe in making smart shopping accessible to everyone. Browse, compare, and discover at no cost whatsoever.',
  },
];

export const guides = [
  {
    title: 'Getting Started with Vigorbuy Sheet',
    description: 'New to curated spreadsheets? Learn how to navigate categories, compare products, and make your first smart purchase using the complete Vigorbuy system.',
    icon: 'ri-compass-3-line',
  },
  {
    title: 'How to QC Products Like a Pro',
    description: 'Master the art of quality checking with our step-by-step QC guide. Learn what to look for, common red flags, and how to verify product authenticity before buying.',
    icon: 'ri-search-eye-line',
  },
  {
    title: 'Safe Buying Practices Guide',
    description: 'Stay protected while shopping. Our comprehensive safety guide covers payment security, seller verification, shipping insurance, and dispute resolution strategies.',
    icon: 'ri-shield-check-line',
  },
];